import {
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Box,
  Td
} from '@chakra-ui/react';
import React from 'react';
import { ObcErrorType } from '../../apis/Transits.api';

interface props {
  obcErrorDatas: ObcErrorType[] | undefined;
}

export const AnomalyTrainTable: React.FC<props> = (props) => {
  const data = props.obcErrorDatas;

  return (
    <>
      {data?.length !== 0 && (
        <Box
          bgColor='white'
          position='relative'
          borderWidth='5px'
          borderRadius='5'
          gridRow='2/3'
          gridColumn='2/3'
        >
          <TableContainer position='absolute' height='100%' overflowY='auto'>
            <Table variant='simple' color='black'>
              <Thead borderWidth='1px' position='sticky'>
                <Tr>
                  <Th
                    textAlign='center'
                    width='100px'
                    borderWidth='1px'
                    borderColor='black'
                  >
                    時間
                  </Th>
                  <Th
                    textAlign='center'
                    width='100px'
                    borderWidth='1px'
                    borderColor='black'
                  >
                    場所
                  </Th>
                  <Th
                    textAlign='center'
                    width='100px'
                    borderWidth='1px'
                    borderColor='black'
                  >
                    車両
                  </Th>
                  <Th
                    textAlign='center'
                    width='300px'
                    borderWidth='1px'
                    borderColor='black'
                  >
                    乗務員
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {data?.map((obc) => {
                  return (
                    <Tr key={`${obc.train_no}`}>
                      <Td
                        textAlign='center'
                        borderWidth='1px'
                        borderColor='black'
                      >
                        {obc.formated_obc_error_time}
                      </Td>
                      <Td
                        textAlign='center'
                        borderWidth='1px'
                        borderColor='black'
                      >
                        {obc.station_name}
                      </Td>
                      <Td
                        textAlign='center'
                        borderWidth='1px'
                        borderColor='black'
                      >
                        {obc.train_no}
                      </Td>
                      <Td
                        textAlign='center'
                        borderWidth='1px'
                        borderColor='black'
                      >
                        {obc.staff_name}
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
};
